// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: "https://license.kalemyazilim.com:9490",
  authUrl: "https://license.kalemyazilim.com:9488",
  // apiUrl: 'http://kalemerp.com:8390',
  // authUrl: 'http://kalemerp.com:8388',
  refreshTokenNotFound:
    "com.kalem.core.exceptions.RefreshTokenNotFoundException",
  filterableElementSelector: "params",
  cryptoKey: "JR@a?(fLJ9av0yn]",
  entityLockSelector: "lock",
  entityUnlockSelector: "unlock",
  generateCodeSelector: "generatecode",
  changesSelector: "persist",
  relatedCompanySelector: "companies",
  urlEnding: "/",
};
